import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { transformInfoBannerDto } from './info-banner';
export const transformReferralInviteInstructionsOldDto = instructions => ({
  title: instructions.title,
  subtitle: instructions.subtitle,
  footer: instructions.footer,
  imageUrl: instructions.image_url,
  learnMoreUrl: instructions.learn_more_url || '',
  termsUrl: instructions.terms_url || ''
});
export const transformHowInviteInstructionWorksDto = howItWorks => ({
  title: howItWorks.title,
  subtitle: howItWorks.subtitle,
  imageUrl: howItWorks.image_url
});
export const transformReferralInviteInstructionsNewDto = instructions => _objectSpread(_objectSpread({}, transformReferralInviteInstructionsOldDto(instructions)), {}, {
  howItWorks: instructions.how_it_works.map(transformHowInviteInstructionWorksDto),
  images: _objectSpread({}, instructions.images),
  referralsIcon: instructions.referrals_icon,
  howItWorksIcon: instructions.how_it_works_icon,
  referralsButtonTitle: instructions.referrals_button_title,
  howItWorksScreenTitle: instructions.how_it_works_screen_title
});
export const transformReferralInviteInstructionsDto = instructions => {
  if ('how_it_works' in instructions) return transformReferralInviteInstructionsNewDto(instructions);
  return transformReferralInviteInstructionsOldDto(instructions);
};

const transformReferralRegistrationDto = referral => ({
  id: referral.id,
  name: referral.name,
  userId: referral.user_id,
  photoUrl: referral.photo_url,
  subtitle: referral.subtitle || ''
});

export const transformReferralOldRegistrationsDto = referrals => referrals.map(transformReferralRegistrationDto);
export const transformReferralRegistrationFriendDto = friend => ({
  userId: friend.user_id,
  name: friend.name,
  photoUrl: friend.photo_url,
  note: friend.note,
  completed: friend.completed,
  subtitle: friend.subtitle
});
export const transformReferralRegistrationFriendsDto = friends => ({
  title: friends.title,
  footer: friends.footer,
  infoBanner: friends.info_banner && transformInfoBannerDto(friends.info_banner),
  list: friends.list.map(transformReferralRegistrationFriendDto),
  emptyState: friends.empty_state && {
    title: friends.empty_state.title,
    body: friends.empty_state.body,
    imageUrl: friends.empty_state.image_url
  }
});
export const transformReferralRegistrationRewardDto = reward => ({
  id: reward.id,
  title: reward.title,
  subtitle: reward.subtitle,
  status: reward.status
});
export const transformReferralRegistrationRewardsDto = rewards => ({
  title: rewards.title,
  footer: rewards.footer,
  infoBanner: rewards.info_banner && transformInfoBannerDto(rewards.info_banner),
  list: rewards.list.map(transformReferralRegistrationRewardDto),
  emptyState: rewards.empty_state && {
    title: rewards.empty_state.title,
    body: rewards.empty_state.body,
    imageUrl: rewards.empty_state.image_url
  }
});
export const transformReferralRegistrationNewDto = dto => ({
  screenTitle: dto.screen_title,
  referrals: transformReferralRegistrationFriendsDto(dto.referrals),
  rewards: transformReferralRegistrationRewardsDto(dto.rewards)
});
export const transformReferralShareDto = share => ({
  isEnabled: share.is_enabled,
  inviteUrl: share.invite_url
});